import { normalizedLocale } from "../../../common/libs/normalizedLocale";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import style from "./ChangingLanguage.module.css";
import classNames from "classnames";
import { useEffect, useState } from "react";

interface IChangingLanguage {
  onlyDesktop?: boolean;
}

export const ChangingLanguage: React.FC<IChangingLanguage> = ({
  onlyDesktop = false,
}) => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  //@ts-ignore
  const locale = normalizedLocale(i18n.translator.language);

  const changeLng = (lng: "en" | "ru" | "ka") => {
    // Проверяем, что тултип открыт перед изменением языка
    if (!open) return;
    
    localStorage.setItem("i18nextLng", lng);
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(!open);
  };

  // Закрытие тултипа при клике вне области
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      
      // Проверяем, что клик был не на кнопке и не внутри тултипа
      const button = document.querySelector('[data-tooltip-id="changing-language"]');
      const tooltipElement = document.getElementById('changing-language');
      
      if (
        button &&
        !button.contains(target) &&
        tooltipElement &&
        !tooltipElement.contains(target)
      ) {
        setOpen(false);
      }
    };

    // Используем capture phase для более раннего перехвата
    document.addEventListener("mousedown", handleClickOutside, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, [open]);

  // useEffect(() => {
  //     if (locale !== 'kk' || locale !== 'ru' || locale !== 'en') {
  //         const lngLocal = String(
  //             localStorage.getItem('i18nextLng'),
  //         ) as string;

  //         //@ts-ignore
  //         if (lngLocal === 'kk' || lngLocal === 'ru' || lngLocal === 'en') {
  //             localStorage.setItem('i18nextLng', lngLocal);
  //             i18n.changeLanguage(lngLocal);
  //         } else {
  //             localStorage.setItem('i18nextLng', 'kk');
  //             i18n.changeLanguage('kk');
  //         }
  //     }
  // }, []);

  return (
    <div className="">
      <div
        className={classNames(
          onlyDesktop ? "hidden" : "flex gap-4   md:hidden",
        )}
      >
        <button
          type="button"
          onClick={(e) => {
            changeLng("en");
          }}
        >
          <span
            className={classNames(
              style.lngButton,
              locale === "en" ? style.lngActive : "",
              " font-medium  p-[10px] block",
            )}
          >
            {t("common.english_short")}
          </span>
        </button>
        <button
          type="button"
          onClick={(e) => {
            changeLng("ru");
          }}
          className={classNames(" font-bold")}
        >
          {" "}
          <span
            className={classNames(
              style.lngButton,
              locale === "ru" ? style.lngActive : "",
              " font-medium  p-[10px] block",
            )}
          >
            {t("common.russian_short")}
          </span>
        </button>
        <button
          type="button"
          onClick={(e) => {
            changeLng("ka");
          }}
        >
          <span
            className={classNames(
              style.lngButton,
              locale === "ka" ? style.lngActive : "",
              " font-medium  p-[10px] block",
            )}
          >
            {t("common.georgian_short")}
          </span>
        </button>
      </div>
      <button
        type="button"
        data-tooltip-id="changing-language"
        className={classNames(
          "h-6 text-sm items-center gap-1 border-0 outline-none bg-transparent focus:outline-none focus:ring-0 focus:border-0",
          onlyDesktop ? "flex" : "hidden md:flex ",
        )}
        data-tooltip-offset={24}
        style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
        onClick={handleButtonClick}
      >
        {locale === "en" ? "Eng" : locale === "ka" ? "Geo" : "Rus"}
        <img
          src="/icons/arrow-top.svg"
          className={classNames(
            "block h-6 w-6 duration-200 border-0 outline-none",
            open ? "" : "rotate-180",
          )}
          style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
        />
      </button>

      <div className="z-[1000] relative" style={{ pointerEvents: open ? 'auto' : 'none' }}>
        <Tooltip
          id="changing-language"
          className={classNames(style.wrapperTooltip, "drop-shadow-2xl")}
          isOpen={open}
          clickable={true}
          noArrow={true}
          opacity={1}
          place={"bottom-end"}
        >
          <div
            className={classNames(
              style.tooltip,
              "flex flex-col min-w-[208px] p-0 rounded-lg relative left-[21px] overflow-hidden",
            )}
            style={{ pointerEvents: open ? 'auto' : 'none' }}
            onClick={(e) => {
              if (!open) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              e.stopPropagation();
            }}
          >
            <span className={classNames("flex h-10 items-center pl-4 text-sm")}>
              {t("authorization.selectLanguage")}
            </span>
            <button
              type="button"
              className={classNames(
                "flex h-10 items-center px-4 duration-200 text-sm justify-between",
              )}
              disabled={!open}
              style={{ pointerEvents: open ? 'auto' : 'none' }}
              onClick={(e) => {
                if (!open) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                e.stopPropagation();
                changeLng("ru");
              }}
            >
              <span>{t("common.russian")}</span>
              {locale === "ru" && <img src="/icons/check.svg" alt="" />}
            </button>
            <button
              type="button"
              className={classNames(
                "flex h-10 items-center px-4 duration-200 text-sm justify-between",
              )}
              disabled={!open}
              style={{ pointerEvents: open ? 'auto' : 'none' }}
              onClick={(e) => {
                if (!open) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                e.stopPropagation();
                changeLng("en");
              }}
            >
              <span>{t("common.english")}</span>
              {locale === "en" && <img src="/icons/check.svg" alt="" />}
            </button>
            <button
              type="button"
              className={classNames(
                "flex h-10 items-center px-4 duration-200 text-sm justify-between",
              )}
              disabled={!open}
              style={{ pointerEvents: open ? 'auto' : 'none' }}
              onClick={(e) => {
                if (!open) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                e.stopPropagation();
                changeLng("ka");
              }}
            >
              <span>{t("common.georgian")}</span>
              {locale === "ka" && <img src="/icons/check.svg" alt="" />}
            </button>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};
